import { lazy, Suspense } from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import history from '../utilites/history';
import Segments from '../constants/Segments';
import ProductTypesUrl from '../constants/ProductTypesUrl';
import CheckoutSteps from '../constants/CheckoutSteps';
import Config from '../config/config';
import PageUrls from '../constants/PageUrls';
import Loader from '../views/components/loader/Loader';
import TopupPageContainer from '../views/pages/topup';
import CampaignDigitalP2PFail from '../views/pages/campaign/digitalP2P/CampaignDigitalP2PFail';
import { ReceiveFromTnAccountContainer } from '../auth/ReceiveFromTnAccount';
const MnpContainer = lazy(() => import('../views/pages/xnp/mnp/Container'));
const FnpContainer = lazy(() => import('../views/pages/xnp/fnp/Container'));
const MnpTransactionStatus = lazy(() => import('../views/pages/xnp/common/transaction-status/TransactionStatusView'));
const Layout = lazy(() => import('../views/layout/Layout'));
const MaintenancePage = lazy(() => import('../views/pages/maintenance'));
const ErrorPage = lazy(() => import('../views/pages/errors'));
const CheckoutContainer = lazy(() => import('../views/pages/checkout'));
const TransactionOverviewContainer = lazy(() => import('../views/pages/checkout/transaction-overview'));
const NotFoundPage = lazy(() => import('../views/pages/not-found'));
const AdditionalProductsContainer = lazy(() => import('../views/pages/additional-products'));
const AdditionalProductsAllContainer = lazy(() => import('../views/pages/additional-products-all'));
const ProductInsuranceContainer = lazy(() => import('../views/pages/product-insurance'));
const ProductListPageContainer = lazy(() => import('../views/pages/product-list'));
const ProductOverviewPageContainer = lazy(() => import('../views/pages/product-overview'));
const ProductOverviewManhattanPageContainer = lazy(() => import('../views/pages/checkout/product-overview'));
const ShoppingCartContainer = lazy(() => import('../views/pages/checkout/shopping-cart'));
const CampaignListPageContainer = lazy(() => import('../views/pages/campaign/list/CampaignListPageContainer'));
const CampaignOverviewPageContainer = lazy(
  () => import('../views/pages/campaign/overview/CampaignOverviewPageContainer')
);
const CampaignAcceptancePageContainer = lazy(
  () => import('../views/pages/campaign/acceptance/CampaignAcceptancePageContainer')
);
const CampaignSuccessPage = lazy(() => import('../views/pages/campaign/success/CampaignSuccessPage'));
const CampaignDetailsPageContainer = lazy(() => import('../views/pages/campaign/details/CampaignDetailsPageContainer'));
const CampaignSmsElectroPageContainer = lazy(
  () => import('../views/pages/campaign/electro/CampaignSmsElectroPageContainer')
);
const ControlledVisibilityRoute = lazy(() => import('./ControlledVisibilityRoute'));
const WishListPageContainer = lazy(() => import('../views/pages/wish-list'));
const ContractContainer = lazy(() => import('../views/pages/checkout/contract'));
const PersonalizedProductOverviewPageContainer = lazy(() => import('../views/pages/personalized-product-overview'));
const SSOContainer = lazy(() => import('../views/pages/SSO'));
const SSOIntegrationTestFormContainer = lazy(() => import('../views/pages/SSO/internal/SSOintegrationTestForm'));
const PrepaidRegistrationLandingPage = lazy(() => import('../views/pages/prepaid-registration/pr-landing'));
const PrepaidRegistraionConsumerPage = lazy(() => import('../views/pages/prepaid-registration/pr-consumer'));
const PrepaidRegistraionBusinessPage = lazy(() => import('../views/pages/prepaid-registration/pr-business'));
const PrepaidRegistraionBusinessSearchResultsPage = lazy(() => import('../views/pages/prepaid-registration/pr-business-search-results'));
const CreateSessionAndRedirectToVendor = lazy(() => import('../views/pages/prepaid-registration/pr-create-session-and-redirect-to-vendor'));
const PrepaidRegistrationErrorPage = lazy(() => import('../views/pages/prepaid-registration/pr-error'));
const PrepaidRegistrationSuccessPage = lazy(() => import('../views/pages/prepaid-registration/pr-success'));
const PrepaidRegistrationEidPage = lazy(() => import('../views/pages/prepaid-registration/pr-eid'));
const PrepaidRegistrationEidCompletePage = lazy(() => import('../views/pages/prepaid-registration/pr-eid-complete'));

// Instead of BrowserRouter, we use the regular router,
// but we pass in a customer history to it.
const AppRouter = () => (
  <Router history={history}>
    <Suspense fallback={<Loader />}>
      <Layout>
        <Switch>
          {/*Topup checkout */}
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.topup}`}
            component={TopupPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${CheckoutSteps.en.topup}`}
            component={TopupPageContainer}
          />

          {/* XNP */}
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.MNP}`}
            component={MnpContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${PageUrls.sr.MNP}`}
            component={MnpContainer}
          />

          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.FNP}`}
            component={FnpContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${PageUrls.sr.FNP}`}
            component={FnpContainer}
          />

          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.transactionStatus}/:hash`}
            component={MnpTransactionStatus}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${CheckoutSteps.sr.transactionStatus}/:hash`}
            component={MnpTransactionStatus}
          />
          {/* end XNP */}

          {/* Prepaid registration */}
          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}`} component={PrepaidRegistrationLandingPage} />

          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_CONSUMER}`} component={PrepaidRegistraionConsumerPage} />
          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_BUSINESS}`} component={PrepaidRegistraionBusinessPage} />
          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_BUSINESS}/${PageUrls.sr.PREPAID_REGISTRATION_BUSINESS_RESULTS}`} component={PrepaidRegistraionBusinessSearchResultsPage} />

          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_EID}`} component={PrepaidRegistrationEidPage} />
          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_EID}/${PageUrls.sr.PREPAID_REGISTRATION_EID_COMPLETE}`} component={PrepaidRegistrationEidCompletePage} />

          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_REDIRECT}`} component={CreateSessionAndRedirectToVendor} />
          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_ERROR}`} component={PrepaidRegistrationErrorPage} />

          <Route exact path={`${Config.prefixUrl}/:lang/${PageUrls.sr.PREPAID_REGISTRATION}/${PageUrls.sr.PREPAID_REGISTRATION_SUCCESS}`} component={PrepaidRegistrationSuccessPage} />
          {/* End prepaid registration */}

          <Route exact path={`${Config.prefixUrl}/:lang/maintenance`} component={MaintenancePage} />
          <Route exact path={`${Config.prefixUrl}/:lang/not-found`} component={NotFoundPage} />
          <Route exact path={`${Config.prefixUrl}/:lang/error`} component={ErrorPage} />
          <Route path={`${Config.prefixUrl}/session-oauth`} component={ReceiveFromTnAccountContainer} />
          <Route path={`${Config.prefixUrl}/sso`} component={SSOContainer} />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isSSOTestFormVisible}
            path={`${Config.prefixUrl}/sso-test`}
            component={SSOIntegrationTestFormContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.phone}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.phone}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.tablet}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.tablet}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.modem}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.modem}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.accessory}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.accessory}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.watches_and_bracelets}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.watches_and_bracelets}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          {/* only for private segment */}
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isTvVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.tv}/`}
            component={ProductListPageContainer}
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isTvVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.tv}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.optics_equipment}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.optics_equipment}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />

          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.phone}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.phone}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.tablet}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.tablet}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.modem}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.modem}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.laptop}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.BUSINESS_SEGMENT}/${ProductTypesUrl.sr.laptop}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />

          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.phone}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.phone}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.tablet}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.tablet}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.modem}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.modem}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.watches_and_bracelets}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.watches_and_bracelets}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.accessory}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.accessory}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isTvVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.tv}/`}
            component={ProductListPageContainer}
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isTvVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.tv}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.optics_equipment}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.optics_equipment}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />

          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.phone}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.phone}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.tablet}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.tablet}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.modem}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.modem}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.laptop}/`}
            component={ProductListPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.BUSINESS_SEGMENT}/${ProductTypesUrl.en.laptop}/:manufacturer/:productName/`}
            component={ProductOverviewPageContainer}
          />

          {/* Wish list routes*/}
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.WISH_LIST}/`}
            component={WishListPageContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${PageUrls.en.WISH_LIST}/`}
            component={WishListPageContainer}
          />

          {/* Manhattan product overview */}
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.landline}/:bundlePackage/`}
            component={ProductOverviewManhattanPageContainer}
            exact
          />
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.landline}/:bundlePackage/`}
            component={ProductOverviewManhattanPageContainer}
            exact
          />
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.ott}/:bundlePackage/`}
            component={ProductOverviewManhattanPageContainer}
            exact
          />
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.ott}/:bundlePackage/`}
            component={ProductOverviewManhattanPageContainer}
            exact
          />
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.postpaidott}/:bundlePackage/`}
            component={ProductOverviewManhattanPageContainer}
            exact
          />
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${ProductTypesUrl.en.postpaidott}/:bundlePackage/`}
            component={ProductOverviewManhattanPageContainer}
            exact
          />

          {/*Manhattan contract*/}
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.contract}/:manufacturer/:productName/`}
            component={ContractContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${CheckoutSteps.en.contract}/:manufacturer/:productName/`}
            component={ContractContainer}
          />
          {/* Existing customer */}
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.EXISTING_CUSTOMER}/:manufacturer/:productName/`}
            component={PersonalizedProductOverviewPageContainer}
          />
          <Route
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${PageUrls.en.EXISTING_CUSTOMER}/:manufacturer/:productName/`}
            component={PersonalizedProductOverviewPageContainer}
          />

          {/* Manhattan checkout */}
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.shoppingCart}`}
            component={ShoppingCartContainer}
            exact
          />
          <ControlledVisibilityRoute
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${CheckoutSteps.en.shoppingCart}`}
            component={ShoppingCartContainer}
            exact
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.checkout}`}
            component={CheckoutContainer}
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${CheckoutSteps.en.checkout}`}
            component={CheckoutContainer}
          />

          {/*Transaction overview with hash*/}
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.transactionOverview}/:hash/`}
            component={TransactionOverviewContainer}
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${CheckoutSteps.en.transactionOverview}/:hash/`}
            component={TransactionOverviewContainer}
          />
          {/*Transaction overview for old webshop route with hash*/}
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${CheckoutSteps.sr.checkout}/${CheckoutSteps.sr.overview}/:hash/`}
            component={TransactionOverviewContainer}
          />
          {/*Transaction overview with said query parametar for tracking installer*/}
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.transactionOverview}`}
            component={TransactionOverviewContainer}
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${CheckoutSteps.en.transactionOverview}`}
            component={TransactionOverviewContainer}
          />
          {/*Transaction overview with said query parametar for tracking installer*/}
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${CheckoutSteps.sr.transactionOverview}`}
            component={TransactionOverviewContainer}
          />
          <ControlledVisibilityRoute
            exact
            isVisible={Config.isManhattanVisible}
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${CheckoutSteps.en.transactionOverview}`}
            component={TransactionOverviewContainer}
          />
          {/* Campaign start */}
          <Route exact path={`${Config.prefixUrl}/:lang/campaigns/list/`} component={CampaignListPageContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/campaigns/overview/`} component={CampaignOverviewPageContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/campaigns/acceptance/:code/:offerId/:optionId/:tpId`} component={CampaignAcceptancePageContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/campaigns/digitalp2p-fail`} component={CampaignDigitalP2PFail} />
          <Route exact path={`${Config.prefixUrl}/:lang/campaigns/details/:code/:eanex?`} component={CampaignDetailsPageContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/campaigns/sms-electro-transaction`} component={CampaignSmsElectroPageContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/campaigns/success/:hash/`} component={CampaignSuccessPage} />
          {/* Campaign end */}

          {/* Insurance */}
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.INSURANCE}`}
            component={ProductInsuranceContainer}
          />
          <Route
            exact
            path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${PageUrls.en.INSURANCE}`}
            component={ProductInsuranceContainer}
          />

          {/* Insurance */}
          <Route exact path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.ADDITIONAL_PRODUCTS}`} component={AdditionalProductsContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${PageUrls.en.ADDITIONAL_PRODUCTS}`} component={AdditionalProductsContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.ADDITIONAL_PRODUCTS_ALL}/${ProductTypesUrl.sr.watches_and_bracelets}`} component={AdditionalProductsAllContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${PageUrls.en.ADDITIONAL_PRODUCTS_ALL}/${ProductTypesUrl.en.watches_and_bracelets}`} component={AdditionalProductsAllContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/${Segments.sr.PRIVATE_SEGMENT}/${PageUrls.sr.ADDITIONAL_PRODUCTS_ALL}/${ProductTypesUrl.sr.accessory}`} component={AdditionalProductsAllContainer} />
          <Route exact path={`${Config.prefixUrl}/:lang/${Segments.en.PRIVATE_SEGMENT}/${PageUrls.en.ADDITIONAL_PRODUCTS_ALL}/${ProductTypesUrl.en.accessory}`} component={AdditionalProductsAllContainer} />

          <Redirect from='/' to={`${Config.prefixUrl}/sr/${Segments.sr.PRIVATE_SEGMENT}/${ProductTypesUrl.sr.phone}/`} />
        </Switch>
      </Layout>
    </Suspense>
  </Router>
);

export default AppRouter;
